import React from 'react';

/**
 * Generic error boundary to protect route-level views.
 * Logs errors to the console so we can trace crashes in production builds.
 */
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[RouteErrorBoundary] Caught error:', error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props;
      if (fallback) {
        return typeof fallback === 'function'
          ? fallback({ error: this.state.error, info: this.state.info })
          : fallback;
      }

      return (
        <div role="alert" style={{ padding: '32px', textAlign: 'center' }}>
          حدث خطأ غير متوقع أثناء تحميل الصفحة. يرجى المحاولة لاحقاً.
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
